import React from 'react';
import { connect } from 'react-redux';

class Unauthorized extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.state = {
    };
  }

  render() {
      return (
        <p style={{textAlign: 'center', margin: '10px'}}>Oops... something is off course here!  Please notify event about results not displaying.</p>
      );
  }
}

export default connect(undefined, {})(Unauthorized);



// WEBPACK FOOTER //
// ./src/components/Unauthorized.js